<template>
  <div class="rounded-button" :style="buttonStyle">
    <span class="button-text">{{ text }}</span>
    <img :src="customIcon" class="custom-icon" v-if="customIcon" />

    <img
      v-else-if="showArrow && !customIcon"
      class="arrow-icon"
      src="@/assets/img/pc/arrow.png"
    />
  </div>
</template>

<script>
import { px2rem } from '@/utils/px2rem';

export default {
  name: 'RoundedButton',
  props: {
    text: {
      type: String,
      default: '联系我们',
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 40,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    borderRadius: {
      type: Number,
      default: 16,
    },
    textSize: {
      type: Number,
      default: 14,
    },
    useRem: {
      type: Boolean,
      default: true, // 默认使用 rem 单位
    },
    customIcon: {
      type: String,
      default: '', // 默认不使用自定义图标，留空字符串
    },
  },
  computed: {
    buttonStyle() {
      if (this.useRem) {
        // 使用 px2rem 工具函数转换
        return {
          width: px2rem(this.width),
          height: px2rem(this.height),
          borderRadius: px2rem(this.borderRadius),
          fontSize: px2rem(this.textSize),
        };
      } else {
        // 使用 px 单位（会被 postcss-pxtorem 自动转换）
        return {
          width: this.width + 'px',
          height: this.height + 'px',
          borderRadius: this.borderRadius + 'px',
          fontSize: this.textSize + 'px',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rounded-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  // box-shadow: 0 0.125rem 0.5rem rgba(24, 144, 255, 0.3); // 2px 8px / 16
  background: var(--button-background-color);
  &:hover {
    background: var(--button-hover-color);
    // transform: translateY(-0.125rem);
    // box-shadow: 0 0.25rem 0.75rem rgba(24, 144, 255, 0.4); // 4px 12px / 16
  }

  &:active {
    // transform: translateY(0);
    // box-shadow: 0 0.125rem 0.5rem rgba(24, 144, 255, 0.3); // 2px 8px / 16
  }
}

.button-text {
  font-weight: 400;
  color: white;
  margin-top: 2px;
}

.arrow-icon {
  width: 15px;
  margin-left: 10px;
  height: 15px;
  transition: transform 0.3s ease;
}
.custom-icon {
  width: 18px;
  // height: 15px;
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.rounded-button:hover .custom-icon {
  transform: translateX(10px);
}

.rounded-button:hover .arrow-icon {
  transform: translateX(10px);
}
</style>
